require([
    "shared/vendor/es6-collections",
    "shared/util/PromisePolyfill",
    "shared/util/StringPolyfill",
    "shared/util/ObjectPolyfill",
    "shared/util/ArrayIncludesPolyfill",
    "shared/util/ArrayFindPolyfill",
    "shared/util/ElementPolyfill"]);



// WEBPACK FOOTER //
// ./src/shared/util/Polyfill.js